<div class="show-announcements">
  @if (areEligibleShowsAvailable$ | async) {
    <app-events-banner
      [showId]="firstEligibleShowId$ | async"
    ></app-events-banner>
  }
  <div class="show-announcements-header">
    <h3>Announcements</h3>
    <kehe-phoenix-button
      (click)="goToAnnouncements()"
      classAttr="btn btn-link btn-medium"
      iconRightClassAttr="fa fa-chevron-right"
      >View All Announcements</kehe-phoenix-button
    >
  </div>

  @if (sliderElements$ | async; as sliderElements) {
    <div class="carousel-container">
      <kehe-phoenix-image-carousel
        [sliderElements]="sliderElements"
        (imageClickLog)="imageClickLog($event)"
      >
      </kehe-phoenix-image-carousel>
    </div>
  }
</div>

@if (showIntroModal) {
  <kehe-phoenix-video-player-modal
    [selectedVideo]="introVideo"
    (modalEvent)="modalEvent($event)"
  >
  </kehe-phoenix-video-player-modal>
}
